import { AbstractPmsApiService } from "./abstract.service";

/**
 * @class SmsPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService}
 */
export class SmsPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/sms/';
    }

    /**
     * @param {Object} smsData
     * @param {Property} property
     * @returns {Promise.<boolean>}
     */
    send(smsData, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url + 'send', smsData, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @returns {Promise.<object>}
     */
    balance(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url + 'balance', {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/sms.service.js